module.exports = __webpack_public_path__ + "img/40_00_064_677.141ded1b.jpg";